import { Reveal, StaggerGroup, StaggerItem } from "@/components/motion/Reveal";
import { Icon } from "@/components/Icon";
import { FOUNDER } from "@/data/content";
import { Check } from "lucide-react";

export function FounderSection() {
  return (
    <section id="founder" data-testid="founder-section" className="bg-white py-24 md:py-32 scroll-mt-24">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
        {/* Header with logo */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <Reveal className="lg:col-span-4">
            <div className="rounded-xl border border-hairline bg-lightgray p-8 lg:sticky lg:top-28">
              <span className="inline-flex bg-white rounded-md px-3 py-3 border border-hairline">
                <img src="/logo.png" alt="Meridian Vanguard Solutions, LLC" className="h-12 w-auto" />
              </span>
              <p className="mt-6 text-sm font-semibold uppercase tracking-[0.22em] text-accent2">About The Founder</p>
              <h2 className="mt-3 font-heading text-2xl font-bold text-navy leading-tight">{FOUNDER.name}</h2>
              <p className="mt-2 text-steel text-[15px]">{FOUNDER.role}</p>
              <div className="mt-6 flex flex-wrap gap-2">
                <span className="inline-flex items-center gap-2 rounded-full bg-white border border-hairline px-3 py-1.5 text-xs font-medium text-navy">
                  <Icon name="Medal" className="h-3.5 w-3.5 text-accent2" /> Purple Heart
                </span>
                <span className="inline-flex items-center gap-2 rounded-full bg-white border border-hairline px-3 py-1.5 text-xs font-medium text-navy">
                  <Icon name="ShieldCheck" className="h-3.5 w-3.5 text-accent2" /> SDVOSB
                </span>
              </div>
            </div>
          </Reveal>

          <div className="lg:col-span-8">
            <Reveal>
              <p className="font-heading text-2xl md:text-3xl font-semibold text-navy leading-snug">{FOUNDER.intro}</p>
            </Reveal>
            <Reveal delay={0.05}>
              <p className="mt-6 text-steel leading-relaxed text-lg">{FOUNDER.intro2}</p>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-5 text-steel leading-relaxed text-lg">{FOUNDER.intro3}</p>
            </Reveal>

            {/* Structured career sections */}
            <div className="mt-12 space-y-6">
              {FOUNDER.sections.map((s) => (
                <Reveal key={s.title}>
                  <div className="rounded-xl border border-hairline bg-white p-8 transition-shadow duration-300 hover:shadow-[0_14px_32px_rgba(10,35,66,0.07)]">
                    <div className="flex items-center gap-4">
                      <span className="h-12 w-12 shrink-0 rounded-xl bg-navy flex items-center justify-center">
                        <Icon name={s.icon} className="h-6 w-6 text-white" />
                      </span>
                      <h3 className="font-heading text-xl md:text-2xl font-semibold text-navy">{s.title}</h3>
                    </div>
                    <p className="mt-5 text-steel leading-relaxed">{s.body}</p>
                    {s.bullets && (
                      <ul className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2.5">
                        {s.bullets.map((b) => (
                          <li key={b} className="flex items-start gap-2.5 text-navy font-medium text-[15px]">
                            <Check size={16} className="text-accent2 mt-1 shrink-0" />
                            {b}
                          </li>
                        ))}
                      </ul>
                    )}
                    {s.after && <p className="mt-4 text-steel leading-relaxed">{s.after}</p>}
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal>
              <div className="mt-8 rounded-xl bg-navy p-8 md:p-10">
                <p className="font-heading text-xl md:text-2xl font-semibold text-white leading-snug">{FOUNDER.closing}</p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
